import { ReactNode, useEffect } from 'react'
import { useLocation, Navigate } from 'react-router-dom'
import { Box, CircularProgress, Typography } from '@mui/material'
import { useAuth } from '../contexts/AuthContext'

interface AuthWrapperProps {
  children: ReactNode
}

export default function AuthWrapper({ children }: AuthWrapperProps) {
  const { isAuthenticated, loading, error } = useAuth()
  const location = useLocation()

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f5f5f5',
        }}
      >
        <CircularProgress size={48} sx={{ color: '#007f98', mb: 2 }} />
        <Typography variant="h6" color="textSecondary">
          Checking authentication...
        </Typography>
      </Box>
    )
  }

  // If not authenticated, redirect to login with current path
  if (!isAuthenticated) {
    const redirectPath = location.pathname + location.search
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirectPath)}`} replace />
  }

  // If authenticated, render the protected content
  return <>{children}</>
}